<script lang="ts">
    import { postMail } from "../../api"
    import { contentFloater, navigateTo } from "../../helper"
    import { _ } from "svelte-i18n"
    import { newNotification, removeNotification, location } from "../../store"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import Checkbox from "../widgets/Checkbox.svelte"
    import { setUser } from "../../sentry"
    import { initialLocale } from "../../i18n"

    export let lang = "de"

    let request: any = {}

    let notif: NotificationEntry
    let submitLoading = false
    function submitRequest() {
        submitLoading = true
        removeNotification(notif)

        postMail("requestForAccount", request)
            .then(() => {
                notif = newNotification({
                    class: "success",
                    html: $_("account.requestForwarded"),
                })
                // add to sentry tracking
                setUser({
                    email: request?.email,
                })
                request = {}
                navigateTo("/")
            })
            .catch((e) => {
                console.log(e)
                notif = newNotification({
                    class: "error",
                    html: $_("account.errorOccurred"),
                    timeout: 10000,
                    removeOnNewLocation: true,
                })
            })
            .finally(() => {
                submitLoading = false
            })
    }
</script>

<section id="login" class="section_padding" data-lang="{lang}">
    <div class="container">
        <!-- Kundenstamm Änderungen -->
        <h1>{$_("account.requestAccess")}</h1>

        {#if $location.search?.includes("ref=eShop")}
            <p>{$_("account.registrationNotice")}</p>
            <p>{$_("account.registrationDescription")}</p>
            <h2>{$_("account.informationAvailableTitle")}</h2>
            <ul>
                <li>{$_("account.statusQuery")}</li>
                <li>{$_("account.downloadDocuments")}</li>
                <li>{$_("account.downloadImages")}</li>
                <li>{$_("account.tracking")}</li>
                <li>{$_("account.customerLink")}</li>
                <li>{$_("account.recognizeChargeable")}</li>
                <li>{$_("account.viewInvoices")}</li>
                <li>{$_("account.andMore")}</li>
            </ul>

            <h2>{$_("account.oneClickSolutionTitle")}</h2>
            <ul>
                <li>{$_("account.inquiryExample")}</li>
                <li>{$_("account.requestManual")}</li>
            </ul>

            <h2>{$_("account.registerNow")}</h2>
        {/if}
        <form style="margin-bottom:40px;" on:submit|preventDefault="{submitRequest}">
            <h3>{$_("account.companyData")}</h3>
            <input type="number" placeholder="{$_('account.customerNumber')}" bind:value="{request.number}" required />
            <input type="text" placeholder="{$_('account.company')}" bind:value="{request.company}" required />
            <input
                type="text"
                placeholder="{$_('account.streetAndHouseNumber')}"
                bind:value="{request.street}"
                required
            />
            <div class="row">
                <div class="col-md-6 no-padding-left">
                    <input
                        type="text"
                        placeholder="{$_('account.postcode')}"
                        bind:value="{request.postcode}"
                        required
                    />
                </div>
                <div class="col-md-6 no-padding-right">
                    <input type="text" placeholder="{$_('account.city')}" bind:value="{request.city}" required />
                </div>
            </div>
            <input type="text" placeholder="{$_('account.country')}" bind:value="{request.countryCode}" required />

            <h3>{$_("account.personalAccess")}</h3>
            <div class="row">
                <div class="col-md-6 no-padding-left">
                    <input
                        type="text"
                        placeholder="{$_('account.salutation')}"
                        bind:value="{request.salutation}"
                        required
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 no-padding-left">
                    <input
                        type="text"
                        placeholder="{$_('account.firstName')}"
                        bind:value="{request.firstname}"
                        required
                    />
                </div>
                <div class="col-md-6 no-padding-right">
                    <input
                        type="text"
                        placeholder="{$_('account.lastName')}"
                        bind:value="{request.lastname}"
                        required
                    />
                </div>
            </div>
            <input type="text" placeholder="{$_('account.position')}" bind:value="{request.position}" required />
            <input type="email" placeholder="{$_('account.email')}" bind:value="{request.email}" required />
            <input type="text" placeholder="{$_('account.phone')}" bind:value="{request.phone}" />
            <input type="text" placeholder="{$_('account.mobilePhone')}" bind:value="{request.mobilePhone}" />
            <input type="text" placeholder="{$_('account.fax')}" bind:value="{request.fax}" />

            <div class="inputholder">
                <Checkbox required="{true}" label=" ">
                    <span>
                        {$_("account.termsAcceptance")}
                        <a href="/{initialLocale}/nutzungsbedingungen" use:contentFloater
                            >{$_("account.termsAndConditions")}</a
                        >
                        {$_("account.acknowledged")}
                    </span></Checkbox
                >
            </div>

            <div class="inputholder">
                <Checkbox required="{true}" label=" ">
                    <span>
                        {$_("account.termsAcceptance")}
                        <a href="/{initialLocale}/datenschutz" use:contentFloater>{$_("account.privacyPolicy")}</a>
                        {$_("account.acknowledged")}</span
                    ></Checkbox
                >
            </div>

            <div style="display:flex; justify-content: flex-end;">
                {#if submitLoading}
                    <MiniLoader />
                {:else}
                    <button class="btn" type="submit">{$_("account.submitRequest")}</button>
                {/if}
            </div>
        </form>
    </div>
</section>
